import { defaultFclCargo, defaultLclCargo, QuoteRequestFormState, toInsuranceQR } from 'features/BookingFlow'
import { PortOrAddress } from 'features/Directory'

import { IBookingTemplateWithLocation } from '../BookingTemplate'

export const fromTemplate = (template: IBookingTemplateWithLocation): Omit<QuoteRequestFormState, 'cargoReadyAt'> => {
  const snapshot: Omit<QuoteRequestFormState, 'cargoReadyAt'> = {
    type: template.type,
    modes: template.modes,
    origin: template.journey.origin as PortOrAddress,
    destination: template.journey.destination as PortOrAddress,
    cargoFcl: [defaultFclCargo],
    cargoLcl: [defaultLclCargo],
    customs:
      template.services.customsSelected || (!!template.services.customsIssuance && !!template.services.customsBondType),
    hsCodesCount: template.services.hsCodesCount,
    insuranceEnabled: !!(template.services.insurances && template.services.insurances.length > 0),
    insurance: toInsuranceQR(template.services.insurances),
    specialEquipment: template.services.specialEquipment,
    dangerousGoods: template.services.dangerousGoods,
    customsIssuance: template.services.customsIssuance,
    customsBondType: template.services.customsBondType || '',
    vgm: template.services.vgm || false,
    incoTerm: template.incoTerm,
    bookingParty: template.bookingParty,
    carbonOffsetService: template.services.carbonOffset,
  }

  return snapshot
}
